import {
  List,
  ListItem,
  ListItemText,
  Divider,
  Typography
} from '@material-ui/core';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';

const SatisfactionList = (props) => {
  const { methodicArray } = props;
  const [renderArrayState, setRenderArrayState] = useState([]);
  SatisfactionList.propTypes = {
    methodicArray: PropTypes.array.isRequired
  };

  const renderColorByAnswer = (index) => {
    switch (index) {
      case 1:
      case 2:
        return '#FF7E79';
      case 3:
      case 4:
      case 5:
        return 'yellow';
      case 6:
      case 7:
        return 'lightgreen';
      default:
        break;
    }
  };

  const generateListTemplate = () => {
    const sortedArray = methodicArray[0].Questions.sort((a, b) => b.AnswerValue - a.AnswerValue);
    const renderArray = [];
    for (let i = 0; i < sortedArray.length; i++) {
      const singleObject = {
        index: i + 1,
        name: sortedArray[i].Text,
        color: renderColorByAnswer(sortedArray[i].AnswerValue),
        answer: sortedArray[i].AnswerValue === 0 ? 0 : sortedArray[i].AnswerTemplateMethodic[sortedArray[i].AnswerTemplateMethodic.findIndex((j) => j.Value === sortedArray[i].AnswerValue)].Text
      };
      renderArray.push(singleObject);
    }

    setRenderArrayState(renderArray);
  };

  useEffect(() => { generateListTemplate(); }, [methodicArray]);

  return (
    <>
      <Divider />
      <List component="nav" aria-label="secondary mailbox folders">
        {renderArrayState.map((item) => (
          <ListItem button style={{ backgroundColor: item.color, textAlign: 'center' }}>
            <ListItemText
              primary={(
                <b>{item.name}</b>
              )}
              disableTypography
              secondary={<Typography type="h5" sx={{ fontWeight: 800, color: 'black', fontStyle: 'italic' }}>{item.answer}</Typography>}
            />
          </ListItem>
        ))}
      </List>
    </>
  );
};

export default SatisfactionList;
